import { ROLE_PALETTE } from "../../constants/formflow/fieldTypes";

export const genId = () => Date.now().toString(36) + Math.random().toString(36).substr(2, 5);

export const roleColor = (roles, roleId) => {
    const i = roles.findIndex((r) => r.id === roleId);
    return ROLE_PALETTE[Math.max(0, i) % ROLE_PALETTE.length];
};

export const getFileUrl = (filePath = "") => {
    return filePath.startsWith("/") ? filePath : `/${filePath}`;
};
